import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDesktop = () => {
  return (
    <g>
      <path d="m14.1773 1.1894h-12.3545a1.7021 1.7021 0 0 0 -1.7 1.7v7.4824a1.7021 1.7021 0 0 0 1.7 1.7h3.9658l-.4847 1.3382h-1.2199a.7.7 0 1 0 0 1.4h7.832a.7.7 0 0 0 0-1.4h-1.22l-.4847-1.3379h3.9658a1.7021 1.7021 0 0 0 1.7-1.7v-7.4821a1.7021 1.7021 0 0 0 -1.6998-1.7006zm-4.9703 12.2206h-2.414l.4847-1.3379h1.4447zm5.27-3.0381a.3.3 0 0 1 -.3.3h-12.3542a.3.3 0 0 1 -.3-.3v-7.4819a.3.3 0 0 1 .3-.3h12.3544a.3.3 0 0 1 .3.3z" />
    </g>
  );
};

export default withIcon(IconDesktop);
